// extracted by mini-css-extract-plugin
export var wrapper = "TripleLinks-module--wrapper--FiAAE";